import React, { useContext } from "react";
import MyContext from "../../context/Data/Context";
import Layout from "../../Component/layout/Layout";
import Loader from "../../Component/Loder/Loder";

function Order() {
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const userId = currentUser && currentUser.user ? currentUser.user.uid : null;

  console.log("userId", userId);
  const context = useContext(MyContext);
  const { mode, loading, order } = context;
  console.log("order", order);

  return (
    <div>
      <Layout>
        {loading && <Loader />}
        {order && order.length > 0 ? (
          <div className=" h-full pt-10">
            {order
              .filter((user) => user.uid === userId)
              .map((order) => {
                console.log("order inside-->", order);
                return (
                  <div
                    key={order.orderId}
                    className="mx-auto max-w-5xl justify-center px-6 md:flex md:space-x-6 xl:px-0"
                  >
                    {order.cartItem.map((item) => {
                      return (
                        <div key={item.itemId} className="rounded-lg md:w-2/3">
                          <div
                            className="justify-between mb-6 rounded-lg bg-white p-6 shadow-md sm:flex sm:justify-start"
                            style={{
                              backgroundColor: mode === "dark" ? "#282c34" : "",
                              color: mode === "dark" ? "white" : "",
                            }}
                          >
                            <img
                              src={item.imageurl}
                              alt="product-image"
                              className="w-full rounded-lg sm:w-40"
                            />
                            <div className="sm:ml-4 sm:flex sm:w-full sm:justify-between">
                              <div className="mt-5 sm:mt-0">
                                <h2
                                  className="text-lg font-bold text-gray-900"
                                  style={{
                                    color: mode === "dark" ? "white" : "",
                                  }}
                                >
                                  {item.title}
                                </h2>
                                <p
                                  className="mt-1 text-xs text-gray-700"
                                  style={{
                                    color: mode === "dark" ? "white" : "",
                                  }}
                                >
                                  {item.discription}
                                </p>
                                <p
                                  className="mt-1 text-xs text-gray-700 font-bold text-4xl"
                                  style={{
                                    color: mode === "dark" ? "white" : "",
                                  }}
                                >
                                  ₹{item.price}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        ) : (
          <h2 className="text-center text-2xl text-white">Not Ordered</h2>
        )}
      </Layout>
    </div>
  );
}

export default Order;
